/**
 * 博士统考路由信息
 */
export default {
  name: 'unifieddoctor',
  path: 'unifieddoctor',
  component: resolve => require(['../../components/pages/unifieddoctor'], resolve),
  redirect: 'unifieddoctor/reviewScore',
  children: [{
    name: 'reviewScore',
    path: 'reviewScore',
    component: resolve => require(['../../components/pages/unifieddoctor/UnifiedDoctorScoreReview'], resolve)
  }, {
    name: 'healthReport',
    path: 'healthReport',
    component: resolve => require(['../../components/pages/unifieddoctor/reexamine/UnifiedDoctorHealthReport'], resolve)
  }, {
    name: 'materialSubmit',
    path: 'materialSubmit',
    component: resolve => require(['../../components/pages/unifieddoctor/reexamine/UnifiedDoctorMaterialSubmit'], resolve)
  }, {
    name: 'materialDownload',
    path: 'materialDownload',
    component: resolve => require(['../../components/pages/unifieddoctor/reexamine/UnifiedDoctorMaterialDownload'], resolve)
  }, {
    name: 'queryResult',
    path: 'queryResult',
    component: resolve => require(['../../components/pages/unifieddoctor/reexamine/UnifiedDoctorQueryResult'], resolve)
  }, {
    name: 'supplement',
    path: 'supplement',
    component: resolve => require(['../../components/pages/unifieddoctor/enroll/EnrollContactSupplement'], resolve)
  }, {
    name: 'certificateExamine',
    path: 'certificateExamine',
    component: resolve => require(['../../components/pages/unifieddoctor/enroll/FreshGraduateCertificateExamine'], resolve)
  }, {
    name: 'admissionNotice',
    path: 'admissionNotice',
    component: resolve => require(['../../components/pages/unifieddoctor/enroll/EnrollContactAdmissionNoticeExpressQuery'], resolve)
  }]
}



// WEBPACK FOOTER //
// ./src/router/pages/unifieddoctor.js